import { Skeleton } from '@monksflow/monks-ui';

/**
 * Pane-region placeholder while the collection list loads and the workspace
 * still has nothing to hand off to. Mirrors `CollectionFilesPane`'s own
 * pending shape so the region does not jump once the first collection opens.
 */
export function CollectionsPaneLoading() {
  return (
    <div
      data-testid="collections-pane-loading"
      className="flex min-h-0 flex-1 flex-col gap-xl rounded-lg bg-card p-xl"
    >
      <div className="flex items-start gap-md">
        <Skeleton className="size-14 shrink-0 rounded-sm" />
        <div className="flex min-w-0 flex-1 flex-col gap-3xs">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-5 w-48" />
        </div>
      </div>
      <Skeleton className="h-10 w-[420px]" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
}

CollectionsPaneLoading.displayName = 'CollectionsPaneLoading';
